/* eslint-disable react/no-typos */
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import {
  NewEmail,
} from 'views/index';
import { ReportRoutes, SetupRoutes, ObjectRoutes } from './components/index';


class MainContent extends React.Component {
  componentDidMount() {
    const { history, location } = this.props;
    if (location.pathname === '/') {
      history.push('/dashboard');
    }
  }

  render() {
    return (
      <div>
        <ReportRoutes />
        <SetupRoutes />
        <Switch>
          <Route path="/:objectType/:objectId/email/new" component={NewEmail} />
        </Switch>
        <ObjectRoutes />
      </div>
    );
  }
}

export default withRouter(MainContent);



// WEBPACK FOOTER //
// ./src/components/page/MainContent/mainContentView.jsx